(function () {
	angular.module('trackeye')
		.directive('onScrollEnd', function () {
			return {
				restrict: "A",
				link: function (scope, element, attrs) {
					var raw = element[0];

					element.bind('scroll', function () {
						if ((raw.scrollTop + raw.offsetHeight) >= (raw.scrollHeight-100)) {
							scope.$apply(attrs.onScrollEnd);
						}
					});
				}
			};
		});
})();